import { EventEmitter, Injectable } from '@angular/core';

import { ProgressType
       } from 'app/controls/progress-overlay/progress-overlay.component';
import { ProductDesignerConfig } from './product-designer-config';

export interface SuspendConfig
{
  suspend: boolean;
  progressType?: ProgressType;
  finished?: boolean;
}

@Injectable()
export class ProductDesignerService
{
  public suspendDesignerTrigger: EventEmitter<SuspendConfig> =
      new EventEmitter();

  public config: ProductDesignerConfig = undefined;
}
